export default {
	ra: {
		auth: {
			login: 'Login',
		},
	},
};
